import Login from './views/login/Login.vue';
import Dashboard from './views/menu/Dashboard';
import NovoTeste from './views/menu/NovoTeste.vue';
import MeusTestes from './views/menu/MeusTestes.vue';
import Cadastro from './views/menu/Cadastro.vue';
import FaleConosco from './views/menu/FaleConosco.vue';
import Teste from './views/menu/Teste.vue';
import ProvasConcursos from './views/menu/ProvasConcursos.vue';
import MeuCadastro from './views/menu/MeuCadastro.vue';
import RegistrarUsuario from './views/public/RegistrarUsuario.vue';
import RedefinirSenha from './views/login/RedefinirSenha.vue';

export const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: { expiredToken: false },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    breadCrumb: 'Dashboard',
    meta: { requiresAuth: true },
  },
  {
    path: '/novo-teste',
    name: 'novoTeste',
    component: NovoTeste,
    breadCrumb: 'Novo teste',
    meta: { requiresAuth: true }
  },
  {
    path: '/novo-teste/:teste',
    name: 'novoTesteModo',
    component: Teste,
    breadCrumb: 'Teste Tutor',
    meta: { requiresAuth: true },
  },
  {
    path: '/meus-testes',
    name: 'meusTestes',
    component: MeusTestes,
    breadCrumb: 'Meus testes',
    meta: {requiresAuth: true}
  },
  {
    path: '/minhas-aulas',
    name: 'minhasAulas',
    beforeEnter() {                    
      window.open("https://app.nutror.com/v3/", 
      '_blank');
  },
    meta: {requiresAuth: true}
  },
  {
    path: '/provas-concursos',
    name: 'provasConcursos',
    component: ProvasConcursos,
    breadCrumb: 'Provas de concursos',
    meta: { requiresAuth: true },
  },
  {
    path: '/meu-cadastro',
    name: 'meuCadastro',
    component: MeuCadastro,
    breadCrumb: 'Meu cadastro',
    meta: { requiresAuth: true },
  },
  {
    path: '/registrar-usuario',
    name: 'registrarUsuario',
    component: RegistrarUsuario,
    breadCrumb: 'RegistrarUsuario',
    meta: { expiredToken: false }
  },
  {
    path: '/area-administrativa/cadastro',
    name: 'areaAdministrativa',
    component: Cadastro,
    breadCrumb: 'Area administrativa',
    meta: { requiresAuth: true },
  },
  {
    path: '/fale-conosco',
    name: 'faleConosco',
    component: FaleConosco,
    breadCrumb: 'Fale Conosco',
    meta: { requiresAuth: true },
  },
  {
    path: '/redefinir-senha',
    name: 'redefinirSenha',
    component: RedefinirSenha,
    breadCrumb: 'Redefinir senha'
  },
];
